import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

interface State {
	agentData: AgentDetails | undefined;
}

export type AgentDetails = {
	id: string;
	identity_account_id?: string | null;
	named_id: string;
	name: string;
	description: string | null;
	system_prompt_template?: string | null;
	creator_type: 'SYSTEM' | 'CUSTOMER' | 'THIRD_PARTY' | 'FORGE';
	creator?: string | null;
	visibility?: 'PUBLIC' | 'PRIVATE' | null;
	is_default: boolean;
	actor_type: 'AGENT';
	creator_cloud_id?: string | null;
	follow_up_prompt_template?: string | null;
	plugin_routing_type?: 'DEFAULT' | 'SKIP' | null;
	user_defined_conversation_starters: string[] | null;
	favourite: boolean;
	deactivated: boolean;
	deactivatedAt?: string;
	favourite_count: number;
};

export type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const setAgentInfo =
	(data: AgentDetails) =>
	({ setState }: StoreApi) => {
		setState({ agentData: data });
	};

const actions = {
	setAgentInfo,
};

const RovoAgentStore = createStore<State, Actions>({
	initialState: {
		agentData: undefined,
	},
	actions,
});

export const useRovoAgentState = createHook(RovoAgentStore, {
	selector: (state) => state.agentData,
});

export const useRovoAgentData = () => {
	const [agentInfo, { setAgentInfo }] = useRovoAgentState();

	return { agentInfo, setAgentInfo };
};
